import React, { useState } from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap';
import { Form, Input, InputPicker } from 'rsuite';
import RedStar from '../../GenericComponents/RedStar';
import { PatternFormat } from 'react-number-format';
import { getStates } from '../../../../services/Shared/codeTable.service'
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import PhoneNumberMask from '../../GenericComponents/PhoneNumberMask';
import TextArea from '../../GenericComponents/TextArea';

function FirmInformation({ isUserEditable, isForApp, isReadOnly }) {
    const [states, setStates] = useState([])

    useEffect(() => {
        getStates().then(setStates);
    }, [])
    return (
        <Card>
            <Card.Header>


                <Row>
                    <Col lg={6}>
                        <h6>Firm Information</h6>
                    </Col>
                    {(isReadOnly && isUserEditable) &&
                        <Col lg={6}>
                            <Row>
                                <Col lg={9}>
                                    <b style={{ color: "#EB0000" }}>NOTE:</b> By clicking the Update Contact Information button, the Update Contact Information section will open in a new tab. After you save your changes in this new tab, close this tab and refresh your page to continue your application, renewal, or reinstatement.</Col>
                                <Col lg={3}><Button as={Link} to="/firm/contactinformation" variant="dark" target="_blank" >
                                    Update Contact Information</Button>
                                </Col>
                            </Row>
                        </Col>
                    }
                </Row>


            </Card.Header>
            <Card.Body>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Firm Name (Domicile)&nbsp;<RedStar />
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control name="name" plaintext />
                        </Col>
                    </Row>
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Federal taxpayer identification number (TIN)&nbsp;<RedStar />
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control plaintext name="federalId" />
                        </Col>
                    </Row>
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>Company Email&nbsp;<RedStar /></strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control plaintext={isReadOnly} name="primaryEmail" />
                        </Col>
                        <Form.HelpText className="d-none">Company Email required</Form.HelpText>

                    </Row>
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Company Website
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control plaintext={isReadOnly} name="url" />
                        </Col>
                        <Form.HelpText className="d-none">Company Website</Form.HelpText>

                    </Row>
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Business Phone <RedStar />
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            {
                                isReadOnly
                                    ?
                                    <Form.Control
                                        accepter={PatternFormat}
                                        name="phoneNum"
                                        plaintext
                                        format="(###) ###-####"
                                        displayType={'text'} />
                                    :
                                    <Form.Control
                                        accepter={PhoneNumberMask}
                                        name="phoneNum"
                                        format="(###) ###-####x#####"
                                        mask="_" />
                            }
                        </Col>
                        <Form.HelpText className="d-none">Business Phone required</Form.HelpText>

                    </Row>
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Contact Person&nbsp;<RedStar />
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control plaintext={isReadOnly} name="contactName" />
                        </Col>
                        <Form.HelpText className="d-none">Contact Person required</Form.HelpText>

                    </Row>
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Type of Firm&nbsp;<RedStar />
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control plaintext name="orgType" />
                        </Col>
                    </Row>
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Domicile Firm State&nbsp;<RedStar />
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control
                                accepter={InputPicker}
                                placeholder="Please Select"
                                block
                                data={states}
                                name="domicileState"
                                searchBy={(userInput, label, dataItem) => { if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput) return true; }}
                                tabIndex="-1"
                                plaintext />
                        </Col>
                    </Row>
                </Form.Group>
                <Form.Group>
                    <Row>
                        <Col sm={3}>
                            <Form.ControlLabel>
                                <strong>
                                    Date Formed/Incorporated (mm/dd/yyyy)&nbsp;<RedStar />
                                </strong>
                            </Form.ControlLabel>
                        </Col>
                        <Col sm={9}>
                            <Form.Control name="dateOfFormation" type="date" plaintext tabIndex="-1" />
                        </Col>
                    </Row>
                </Form.Group>
                <hr />
                <Form.Group>
                    <Row>
                        <Col>
                            <Form.ControlLabel>
                                <strong>
                                    Brief description of services to be provided by the firm in Louisiana <RedStar />
                                </strong>
                                <br />
                                <em>Max 1000 characters including spaces</em>
                            </Form.ControlLabel>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Control
                                accepter={TextArea}
                                rows={5}
                                name="additionalInformation"
                                plaintext={isReadOnly}
                                maxLength={1000} />
                        </Col>
                        <Form.HelpText className="d-none">Brief description of services to be provided by the firm in Louisiana required</Form.HelpText>

                    </Row>
                </Form.Group>
            </Card.Body>
        </Card >
    );
}
export default FirmInformation;